import Section from '@/components/Section'

const SOCIALS = [
  { label: 'TikTok', handle: '@revCharlene', href: 'https://tiktok.com/@revCharlene' },
  { label: 'Instagram', handle: '@revCharlene', href: 'https://instagram.com/revCharlene' },
]

export default function AboutSection() {
  return (
    <div className="py-24 px-6 max-w-[680px] mx-auto">
      <Section>
        <div className="text-center">
          {/* Avatar with glow */}
          <div className="relative mx-auto mb-6 w-[76px] h-[76px]">
            <div className="absolute inset-[-8px] rounded-full bg-gold/8 animate-breathe-slow" />
            <div className="relative w-[76px] h-[76px] rounded-full bg-gradient-to-br from-gold-warm to-gold-light mx-auto flex items-center justify-center text-[36px]">
              ✨
            </div>
          </div>

          <h2 className="font-display text-[clamp(26px,4.5vw,38px)] font-bold text-text-dark leading-[1.15] mb-5">
            Why Listen to Me?
          </h2>

          <p className="text-text-gray text-[17px] leading-[1.85] mb-3">
            I'm not a tech person who stumbled into spirituality. I'm a{' '}
            <strong className="text-text-dark">spiritual leader</strong> who also happens to be an{' '}
            <strong className="text-text-dark">award-winning IT trainer</strong> and{' '}
            <strong className="text-text-dark">AI upskilling mentor</strong>.
          </p>

          <p className="text-text-gray text-[17px] leading-[1.85] mb-3">
            I built every tool on this page because{' '}
            <strong className="text-text-dark">I needed it for my own center</strong> — and
            couldn't find anything that understood how spiritual communities actually work.
          </p>

          <p className="text-text-gray text-[17px] leading-[1.85] mb-8">
            Now I teach other leaders how to use AI and technology to spend less time on admin
            and more time on what AI will never be able to do —{' '}
            <em className="text-brand-mid">show up, hold space, and lead from the heart</em>.
          </p>

          {/* Social links */}
          <div className="flex gap-4 justify-center flex-wrap">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="py-2.5 px-6 rounded-full bg-bg-warm text-brand-mid text-sm font-semibold no-underline border border-card-border transition-all duration-200 hover:bg-brand-mid/10 hover:border-brand-mid/20"
              >
                {s.label}: {s.handle}
              </a>
            ))}
          </div>
        </div>
      </Section>
    </div>
  )
}
